export enum FilterTypeEnum {
    TEXT = 'TEXT',
    DATE = 'DATE',
    DATE_RANGE = 'DATE_RANGE',
    NUMBER = 'NUMBER',
    SELECT = 'SELECT',
}
